<template>
  <div>
    <span v-bind:class="classObject">{{ getStatusText() }}</span>
  </div>
</template>

<script>
export default {
  props: {
    statustype: String,
  },
  methods: {
    getStatusText: function () {
      switch (this.statustype) {
        case "ชำระแล้ว":
          return "ชำระแล้ว";
        case "ค้างชำระ":
          return "ค้างชำระ";
        case "Approved":
          return "อนุมัติ";
        case "WaitApprove":
          return "รออนุมัติ";
        case "ApproveConfirmed":
          return "ยืนยันชั่ง";
        case "Canceled":
          return "ยกเลิก";
        case "NotApproved":
          return "ไม่อนุมัติ";
        case "Billing":
          return "Billing";
        case "Active":
          return "Active";  
        case "InActive":
          return "InActive"; 
        case "Draft":
          return "Draft";                    
        default:
          return "";
      }
    },
  },
  computed: {
    classObject: function () {
      return {
        /*success*/
        "badge badge-success": this.statustype === "ชำระแล้ว" || this.statustype === "Approved",

        /*primary*/
        "badge badge-primary": this.statustype === "ApproveConfirmed" || this.statustype === "Active",

        /*warning*/
        "badge badge-warning": this.statustype === "WaitApprove",

        /*danger*/
        "badge badge-danger":
          this.statustype === "ค้างชำระ" ||
          this.statustype === "Canceled" ||
          this.statustype === "NotApproved",

        /*info*/
        "badge badge-info": this.statustype === "Billing",

        /*secondary*/
        "badge badge-secondary": this.statustype === "InActive" || this.statustype === "Draft" ,
      };
    },
  },
  data() {
    return {
      statusText: "",
    };
  },
};
</script>
